/**
 * Same formula as the homepage's own hero stat (src/components/HomePageIntro.js,
 * HERO_STATS "Development hours"), duplicated rather than imported so this
 * work stays inside src/components/industries/ and touches nothing outside
 * it. Kept in sync deliberately: this is a live, ticking number on the
 * homepage, not a fixed claim, so hardcoding a snapshot here would drift out
 * of agreement with it within days.
 */
const devHours = () => {
  const days = Math.floor((Date.now() - new Date("2026-05-05").getTime()) / 86400000)
  const hours = 230400 + days * 160
  return Math.floor(hours / 1000) + "k"
}

export default devHours
